<template>
  <form
    name="richTextBlogItemForm"
    @submit.prevent="createBlogItem">
    <v-row class="align-center">
      <!-- Title -->
      <v-col>
        <v-text-field
          hide-details
          label="Title"
          placeholder=" "
          v-model="blogItem.title">
        </v-text-field>
      </v-col>
      <!-- / Title -->

      <!-- Date -->
      <v-col cols="auto">
        <DatePicker
          input-id="blog-date"
          v-model="blogItem.date"
          label="Date"
          :line-bottom="true"
        />
      </v-col>
      <!-- / Date -->

      <!-- Hidden -->
      <v-col cols="auto"
        class="hidden-checkbox col-auto">
        <v-checkbox
          height="28"
          label="Hidden"
          v-model="blogHidden">
        </v-checkbox>
      </v-col>
      <!-- / Hidden -->
    </v-row>

    <div class="row">
      <div class="col">
        <label class="d-block mb-1">Image:</label>
        <ImageInput
          v-model="blogItem.imageContent"
          :clearable="true"
        />
      </div>
    </div>

    <v-divider></v-divider>

    <WYSIWYG
      class="page-tab-content-expand"
      v-model="blogItem.content">
    </WYSIWYG>

    <div class="page-buttons d-flex my-5">
      <v-btn
        type="submit"
        color="primary">
        Save
      </v-btn>

      <v-btn
        @click="goToBlogList"
        type="button"
        color="primary"
        class="mr-auto order-first"
        outlined>
        Cancel
      </v-btn>
    </div>
  </form>
</template>

<script>
import BlogItemMixin from '../mixin.blog-item';
import WYSIWYG from './WYSIWYG/WYSIWYG.vue';
import DatePicker from './DatePicker.vue';
import ImageInput from './ImageInput.vue';

export default {
  name: 'BlogCreateForm',
  mixins: [
    BlogItemMixin,
  ],
  components: {
    WYSIWYG,
    DatePicker,
    ImageInput,
  },
};
</script>

<style lang="scss"></style>
